












import Vue from 'vue';

export default Vue.extend({
  name: 'IconCard',
  props: {
    icon: {
      type: String,
      required: true,
    },
    header: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
  },
});
